
import postcssStyledJsxUrlLoader_0 from '../../images/optimizely.png';
import css from 'styled-jsx/css';

export default css.global`/* @styled-jsx=global */

.ab-test-switcher {
  position: relative;

  $self: &;

  &:after,
  &__form {
    z-index: 999;
    position: absolute;
    top: 0;
    left: 10px;
    right: 10px;
  }

  &:after {
    content: '';
    display: block;
    bottom: 0;
    border: 4px solid blue;
    border-radius: 5px;
    pointer-events: none;
  }

  &__form {
    background: transparent url("${postcssStyledJsxUrlLoader_0}");
    background-position: top 10px left 10px;
    background-repeat: no-repeat;
    background-size: 25px;
    padding-left: 45px;
    font-family: monospace;

    display: flex;
    align-items: baseline;
  }

  &__experiment-id {
    color: blue;
    font-weight: bold;
  }

  &__form__field {
    margin-left: 20px;

    label {
      padding: 15px 10px;
      display: inline-block;
    }
  }

  &:after,
  &__form__field {
    transition: all 200ms ease;
    opacity: 0;
  }

  &:hover {
    #{$self}__form__field,
    &:after {
      opacity: 1;
    }
  }
}
`